import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-floors',
  imports: [],
  template: `
<div class="container mt-4 mb-5">
  <div class="row">
    <div class="col-lg-10 offset-lg-1">
      <h1 class="display-5 mb-4">Floor Plans & Features</h1>
      <div class="list-group shadow-sm">
        <div class="list-group-item p-4">
          <h3 class="h5 mb-2">2 Bed / 1 Bath</h3>
          <p class="mb-0 text-muted">Our 2 bedroom units consist of single-story duplexes. All units have off-street driveway parking
          and hookups for an electric washer and dryer. Some units are available with fenced back yards.</p>
        </div>

        <div class="list-group-item p-4">
          <h3 class="h5 mb-2">3 Bed / 2 Bath</h3>
          <p class="mb-0 text-muted">We have a variety of different 3 bedroom floor plans, in both single and two-story duplexes.
          All 3 bedroom units include a driveway with attached garage and hookups for an electric washer and
          dryer. Most units are available with fenced back yards.</p>
        </div>

        <div class="list-group-item p-4">
          <h3 class="h5 mb-2">4 Bedrooms</h3>
          <p class="mb-0 text-muted">We have several different 4 bedroom floor plans, with varying numbers of baths. At Rock Bridge Estates
          we have two-story duplex units with attached garages, washer and dryer hookups and fenced back yards.</p>
        </div>

        <div class="list-group-item p-4">
          <h3 class="h5 mb-2">5 Bed / 1.5 Bath</h3>
          <p class="mb-0 text-muted">We have one 5 bedroom unit located in Rock Bridge Estates. This two-story duplex offers off-street driveway
          parking, hookups for an electric washer and dryer, and a fenced back yard.</p>
        </div>

        <div class="list-group-item p-4 bg-light">
          <h3 class="h5 mb-2">See for yourself!</h3>
          <p class="mb-0">
            Check out the <a href="http://www.youtube.com/user/hakerproperties" target="_blank" class="fw-bold">Haker Properties YouTube Channel</a>
            to see video walkthroughs of all our many different unit styles and floor plans.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
  `,
  styles: ``,
})
export class Floors {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle('Floor Plans - RentMU.com');
    this.metaService.updateTag({ name: 'description', content: 'View our variety of 2, 3, 4, and 5 bedroom floor plans for student housing in Columbia, MO.' });
  }
}
